import {Map, OrderedMap} from "immutable";
import {plainToClass} from "class-transformer";
import User from "../_data/models/User";
import Style from "../_data/models/Style";
import Special from "../_data/models/Special";
import Shop from "../_data/models/Shop";
import Booth from "../_data/models/Booth";
import SearchResult from "../_data/models/SearchResult";
import Model from "../_data/models/Model";
import Conversation from "../_data/models/Conversation";
import Message from "../_data/models/Message";

export const ResourceType = {
    user: 'user',
    shop: 'shop',
    special: 'special',
    style: 'style',
    booth: 'booth',
    search: 'search',
    conversation: 'conversation',
    message: 'message',
};

export function plainToClassFromResourceName(resource: string, data: {}): Model {
    switch (resource.toLowerCase()) {
        case 'user':
            return plainToClass(User, data);
        case 'style':
            return plainToClass(Style, data);
        case 'special':
            return plainToClass(Special, data);
        case 'shop':
            return plainToClass(Shop, data);
        case 'booth':
            return plainToClass(Booth, data);
        case 'search':
            return plainToClass(SearchResult, data);
        case 'conversation':
            return plainToClass(Conversation, data);
        case 'message':
            return plainToClass(Message, data);
    }
}

export function addData<T>(resource: string, data: {} | {}[], map: Map<number, T>) {
    if (Array.isArray(data)) {
        const _map = data.map((i) => {
            const obj = plainToClassFromResourceName(resource, i);
            return [obj.id, obj]
        });
        return map.mergeDeep(OrderedMap<number, T>(_map));

    } else {
        const obj = plainToClassFromResourceName(resource, data);
        return map.mergeDeep(OrderedMap<number, T>([[obj.id, obj]]));
    }
}

export function removeData<T>(id: number, map: Map<number, T>) {
    return map.delete(id);
}

export function updateData<T>(id: number, item: {}, map: Map<number, T>) {
    return map.set(id, item as T);
}


// WEBPACK FOOTER //
// ./app/client/_helpers/data.ts